import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GdxModalPage } from './gdx-modal';
import { FlexLayoutModule } from '@angular/flex-layout';

import * as Hammer from 'hammerjs';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';

export class CustomHammerConfig extends HammerGestureConfig{
  overrides = {
    'pan': {
      direction: Hammer.DIRECTION_ALL
    },
    'swipe': {
      direction: Hammer.DIRECTION_DOWN
    }
  }
}

@NgModule({
  declarations: [
    GdxModalPage,
  ],
  imports: [
    IonicPageModule.forChild(GdxModalPage),
    FlexLayoutModule
  ],
  exports: [
    GdxModalPage
  ],
  providers: [
    { provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig}
  ],
})
export class GdxModalPageModule {}



// WEBPACK FOOTER //
// ./src/components/gdx-modal/gdx-modal.module.ts